/**
 * 设置页面路由，归属主仓layout下，走正常的权限校验
 */
export default [
  {
    path: '/benchmark',
    component: '@/pages/benchmark/layouts/index',
    routes: [
      {
        path: './:frameType',
        routes: [
          // 特性报表
          {
            path: './tableau/report/:reportId',
            component: '@/pages/benchmark/pages/report/tableau',
          },
          {
            path: './preset/report/:reportId',
            component: '@/pages/benchmark/pages/report/preset',
          },
          {
            path: './pdf/report/:reportId',
            component: '@/pages/benchmark/pages/report/pdf',
          },
          {
            path: './cos/report/:reportId',
            component: '@/pages/benchmark/pages/report/cos',
          },
          {
            path: './datalab/customDashboard/:dashboardId',
            component: '@/pages/benchmark/pages/report/datalab',
          },
          {
            path: './looker/report/:reportId',
            component: '@/pages/benchmark/pages/report/looker',
          },
          {
            path: './web/report/:reportId',
            component: '@/pages/benchmark/pages/report/web',
          },
          {
            path: './authPath/report/:reportId',
            component: '@/pages/benchmark/pages/report/auth',
          },
          // 框架报表
          {
            path: './explore',
            component: '@/pages/benchmark/pages/explore',
          },
          {
            path: './explore/metricDetail/:metric',
            component: '@/pages/benchmark/pages/metricDetail',
          },
          {
            path: './explore/metricOtdr/:metric',
            component: '@/pages/benchmark/pages/metricOtdr',
          },
          {
            path: './explore/metricIaa/:metric',
            component: '@/pages/benchmark/pages/metricIaa',
          },
          {
            path: './explore/metricTips/:metric',
            component: '@/pages/benchmark/pages/metricTip',
          },
          {
            path: './genre',
            component: '@/pages/benchmark/pages/genre',
          },
          // IAA Benchmarks 低代码模板页面
          {
            path: './IAABenchmarks',
            component: '@/pages/benchmark/pages/iaaBenchmarks',
          },
        ]
      },
     
    ],
  },
];

/**
 * 不跳转默认路径 白名单
 */
export const WHITE_LIST_OF_ROUTERS = [
  'testPage'
];
export const INDEPENDENT_ROUTERS = [];
